// Icon Parralax
jQuery(document).on('scroll', function() {
    const $ = jQuery;
    const scrollPosition = window.scrollY;
    const leftIcon = $('.left-icon');
    const rightIcon = $('.right-icon');

    leftIcon.css('transform', `translateY(${scrollPosition * 0.1}px) rotate(${scrollPosition * -0.05}deg)`);
    rightIcon.css('transform', `translateY(${scrollPosition * -0.1}px) rotate(${scrollPosition * 0.05}deg)`);
});